import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FlagCircleIcon(props: IconProps) {
    return <Icon {...props} iconKey={"flag_circle"}/>
}
